import React, { Component } from 'react';
import { EmptyState } from 'components';
import { ReactComponent as NotFound } from 'svgs/not_found.svg';

class ErrorScreen extends Component {
	state = {
		hasError: false,
		error: null,
		info: null,
	};

	componentDidCatch(error, info) {
		console.log('ERROR', error);
		console.log('INFO', info);
		this.setState({ hasError: true, error, info });
	}

	render() {
		if (!this.state.hasError) return this.props.children;

		return (
			<EmptyState
				heading="Something went wrong."
				Illustration={NotFound}
				action={{
					text: 'Go to Dashboard',
					url: '/',
				}}
				background='#f6f7fb'
			>
				<details style={{ whiteSpace: 'pre-wrap' }}>
					{this.state.error.toString()}
					<br />
					{this.state.info.componentStack}
				</details>
			</EmptyState>
		);
	}
}

export default ErrorScreen;
